import { AppLayoutProps } from "../types/AppLayout";

export default function AppLayout({ children }: AppLayoutProps): JSX.Element {
  return (
    <div className="flex flex-col h-full w-full bg-backgroundColor">
      {children}
    </div>
  );
}
